var _path, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgZoomIn(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_1714",
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.742,
    height: 20.771,
    viewBox: "0 0 20.742 20.771",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "search",
    d: "M20.442,18.614l-4.7-4.7a8.72,8.72,0,1,0-14-10.4,8.72,8.72,0,0,0,12.2,12.2l4.7,4.7a1.272,1.272,0,0,0,1.8-.1A1.354,1.354,0,0,0,20.442,18.614Zm-17.9-9.9a6.231,6.231,0,0,1,6.2-6.2,6.318,6.318,0,0,1,6.3,6.2,6.338,6.338,0,0,1-6.3,6.3h0A6.253,6.253,0,0,1,2.543,8.714Z",
    transform: "translate(0 0.029)",
    fill: "#fff"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "add",
    transform: "translate(5.784 5.784)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_18",
    y2: 6,
    transform: "translate(3)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_19",
    x1: 6,
    transform: "translate(0 3)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZoomIn);
export default __webpack_public_path__ + "static/media/zoom-in.d320b1065daf968a54586b550cd9037d.svg";
export { ForwardRef as ReactComponent };